import React from 'react';
import { Image } from 'cw-ui-core';
import cx from 'classnames';
import css from './IconTextButton.scss';

const IconTextButton = props => {
    const { alt, disabled, onClick, automationName, icon, buttonClassName, text } = props;
    return (
        <div
            title={alt}
            className={disabled ? cx(css.wrapDisabled, buttonClassName) : cx(css.wrap, buttonClassName)}
            onClick={disabled ? undefined : onClick}
            data-cwid={automationName}>
            <Image
                className={disabled ? css.imageDisabled : css.image}
                src={icon}
                automationName={`img_${automationName}`}
                alt={alt}
            />
            <div className={disabled ? css.textDisabled : css.text} data-cwid={`text_${automationName}`}>
                {text}
            </div>
        </div>
    );
};

export default IconTextButton;
